export default __webpack_public_path__ + "static/media/ddsu5168-5.1a82f555.png";